import React from 'react';

import FormHeader from 'prequalificationV2/components/FormHeader';
import FormBody from 'components/FormBody';
import { MailIcon, PhoneIcon } from 'components/Icons';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';

import styles from './DeclinePage.module.scss';

const FORM_TITLE = 'Unfortunately, your application cannot be created at this time.';
const IT_APPEARS_THAT = 'It appears that Borrower’s email address ';
const HAS_ALREADY_BEEN_USED = ' has already been used by other applicant.';
const MOCK_BORROWERS_EMAIL = 'john.black@gmail.com ';
const HOW_TO_FIX_THIS = 'How to Fix this?';
const PLEASE_REAPPLY = 'Please reapply';
const HERE = 'HERE';
const WHEN_REAPPLYING = 'When reapplying, be sure that you use another EMAIL ADDRESS.';
const HFS_NUMBER = '(800) 254-9560';
const HFS_EMAIL = 'info@hfsfin.com';
const IF_YOU_HAVE_ANY_DIFFICULTIES = 'If you feel you need assistance, please contact HFS Financial at:';

const DeclinePage = () => {
  const handleClickHereButton = () => {};

  return (
    <>
      <FormHeader title={FORM_TITLE} percent={ProgressBarStatus.Failed} />
      <FormBody>
        <div className={styles.bodyFormText}>
          <div className={styles.bodyInformation}>
            {IT_APPEARS_THAT}
            <a className={styles.email}>{MOCK_BORROWERS_EMAIL}</a>
            {HAS_ALREADY_BEEN_USED}
          </div>

          <div className={styles.howToFixText}> {HOW_TO_FIX_THIS}</div>
          <ul className={styles.list}>
            <li>
              {' '}
              {PLEASE_REAPPLY}{' '}
              <span className={styles.here} onClick={handleClickHereButton}>
                {HERE}
              </span>
            </li>
            <li> {WHEN_REAPPLYING} </li>
          </ul>
          <div className={styles.hfsInformationContainer}>
            {IF_YOU_HAVE_ANY_DIFFICULTIES}
            <div className={styles.informationRaw}>
              <PhoneIcon className={styles.icon} />
              {HFS_NUMBER}
            </div>
            <div className={styles.informationRaw}>
              <MailIcon className={styles.icon} />
              {HFS_EMAIL}
            </div>
          </div>
        </div>
      </FormBody>
    </>
  );
};

export default DeclinePage;
